import api from "@/lib/api";

const PAGE_TITLES = {
  "/": "Landing Page",
  "/roadmap": "Data Cloud Roadmap",
  "/sfmc": "SFMC Roadmap",
  "/mc-next": "MC Next Roadmap",
  "/premium": "Premium Upgrade Page",
  "/team": "Team Premium Page",
};

// Collapses dynamic route segments (ids, days, etc.) into a stable slug so the
// analytics dashboard doesn't explode into thousands of unique page_slugs.
export function normalizePageSlug(pathname) {
  const segments = pathname.split("/").map((seg) => (seg && (seg.length > 16 || /^\d+$/.test(seg)) ? ":id" : seg));
  return segments.join("/") || "/";
}

export function trackPageEvent(pageSlug, eventType) {
  const normalized = normalizePageSlug(pageSlug);
  api.post("/page-analytics/track", {
    page_slug: normalized,
    page_title: PAGE_TITLES[normalized] || normalized,
    event_type: eventType,
  }).catch(() => {});
}
